const agentlistdata = [
    {
        id: 1,
        joiningdate: "19 Nov, 2022",
        img: "assets/images/users//avatar-1.jpg",
        imgalt: "avatar-1.jpg",
        name: "Dianna Bogan",
        property: "149",
        location: "Brasília, Brazil",
        email: "dianna@steex.com",
        contact: "(86) 9985-9220",
        status: "Active",
        new: true
    }, {
        id: 2,
        joiningdate: "25 Nov, 2022",
        img: "assets/images/users//avatar-10.jpg",
        imgalt: "avatar-10.jpg",
        name: "Josefa Weissnat",
        property: "164",
        location: "California, USA",
        email: "josefaweissnat@steex.com",
        contact: "(53) 3035-3100",
        status: "Unactive",
        new: false
    }, {
        id: 3,
        joiningdate: "08 Dec, 2022",
        img: "assets/images/users//avatar-9.jpg",
        imgalt: "avatar-9.jpg",
        name: "Ophelia Steuber",
        property: "279",
        location: "Sobrado, Spain",
        email: "opheliasteuber@steex.com",
        contact: "(21) 2345-6789",
        status: "Active",
        new: false
    }, {
        id: 4,
        joiningdate: "21 Dec, 2022",
        img: "assets/images/users//avatar-8.jpg",
        imgalt: "avatar-8.jpg",
        name: "Federico Hand",
        property: "487",
        location: "San Luis Potosi, Mexico",
        email: "federico@steex.com",
        contact: "(11) 3666-9716",
        status: "Active",
        new: false
    }, {
        id: 5,
        joiningdate: "27 Jan, 2023",
        img: "assets/images/users//avatar-7.jpg",
        imgalt: "avatar-7.jpg",
        name: "Uriel King",
        property: "369",
        location: "Ibiza, Spain",
        email: "urielking@steex.com",
        contact: "(92) 3639-8685",
        status: "Unactive",
        new: true
    }, {
        id: 6,
        joiningdate: "18 Feb, 2023",
        img: "assets/images/users//avatar-6.jpg",
        imgalt: "avatar-6.jpg",
        name: "Buck Roberts",
        property: "495",
        location: "Guarulhos, Brazil",
        email: "buckroberts@steex.com",
        contact: "(11) 3885-1022",
        status: "Active",
        new: false
    }, {
        id: 7,
        joiningdate: "24 Feb, 2023",
        img: "assets/images/users//avatar-5.jpg",
        imgalt: "avatar-5.jpg",
        name: "Xander Wyman",
        property: "85",
        location: "Logrono, Spain",
        email: "xander@steex.com",
        contact: "(48) 3877-9000",
        status: "Unactive",
        new: true
    }, {
        id: 8,
        joiningdate: "29 Feb, 2023",
        img: "assets/images/users//avatar-4.jpg",
        imgalt: "avatar-4.jpg",
        name: "Donnell Schultz",
        property: "326",
        location: "Natal, Brazil",
        email: "donnell@steex.com",
        contact: "(51) 3233-7909",
        status: "Active",
        new: false
    }, {
        id: 9,
        joiningdate: "11 Mar, 2023",
        img: "assets/images/users//avatar-3.jpg",
        imgalt: "avatar-3.jpg",
        name: "Jacinthe Will",
        property: "741",
        location: "Brasília, Brazil",
        email: "dianna@steex.com",
        contact: "(33) 3521-6761",
        status: "Active",
        new: true
    }, {
        id: 10,
        joiningdate: "15 Mar, 2023",
        img: "assets/images/users//avatar-10.jpg",
        imgalt: "avatar-10.jpg",
        name: "Josefa Weissnat",
        property: "159",
        location: "California, USA",
        email: "josefaweissnat@steex.com",
        contact: "(53) 3035-3100",
        status: "Unactive",
        new: false
    }, {
        id: 11,
        joiningdate: "17 Mar, 2023",
        img: "assets/images/users//avatar-6.jpg",
        imgalt: "avatar-6.jpg",
        name: "Buck Roberts",
        property: "149",
        location: "Guarulhos, Brazil",
        email: "buckroberts@steex.com",
        contact: "(11) 3885-1022",
        status: "Active",
        new: false
    }
];

export { agentlistdata };